import { List, Null, Value } from './ast'
import { Pt, pt } from '../base/pt'

function cons(head: Value, tail: List | Null): List {
    return {
        type: "list",
        head: head,
        tail: tail
    }
}

function reverse(list: List | Null, acc: List | Null) {
    if (list.type == "null")
        return acc;
    return reverse(list.tail, cons(list.head, acc));
}

function array(list: List): Value[] {
    const result: Value[] = [];
    let idx: List | Null = list;
    while (idx.type == "list") {
        result.push(idx.head);
        idx = idx.tail;
    }
    return result;
}

function toPt(list: List): Pt {
    const x = list.head;
    if (x.type != "number")
        throw new Error("Expected number for x");
    if (list.tail.type != "list")
        throw new Error("No value for y");
    if (list.tail.head.type != "number")
        throw new Error("Expected number for y");
    const y = list.tail.head;
    return pt(x.value, y.value);
}

export { cons, reverse, array, toPt }